// src/pages/CheckoutPage.jsx
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "../Styles/CheckoutPage.css";

const CheckoutPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const booking = location.state?.booking;
    const [guestName, setGuestName] = useState("");
  const [guestEmail, setGuestEmail] = useState("");
  const [guestPhone, setGuestPhone] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("card");

  useEffect(() => {
    if (!booking) navigate("/all-listings");
  }, [booking, navigate]);

  if (!booking) return null;



  const handleConfirmBooking = () => {
    alert(`Booking confirmed for ${guestName}! Total: AED ${booking.totalPrice.toLocaleString()}`);
    navigate("/all-listings");
  };

  return (
    <div className="checkout-page">
      <div className="checkout-header">
        <FaArrowLeft className="back-icon" onClick={() => navigate(-1)} />
        <h1>Checkout</h1>
      </div>

      <div className="checkout-grid">
        {/* LEFT FORM */}
        <div className="checkout-left">
          <h2>Guest Information</h2>
          <form onSubmit={(e) => { e.preventDefault(); handleConfirmBooking(); }}>
            <label>
              Full Name
              <input
                type="text"
                value={guestName}
                onChange={(e) => setGuestName(e.target.value)}
                required
              />
            </label>

            <label>
              Email
              <input
                type="email"
                value={guestEmail}
                onChange={(e) => setGuestEmail(e.target.value)}
                required
              />
            </label>

            <label>
              Phone Number
              <input
                type="tel"
                value={guestPhone}
                onChange={(e) => setGuestPhone(e.target.value)}
                required
              />
            </label>

            <h2>Payment Method</h2>
            <div className="payment-options">
              <label>
                <input
                  type="radio"
                  value="card"
                  checked={paymentMethod === "card"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                Credit/Debit Card
              </label>
              <label>
                <input
                  type="radio"
                  value="paypal"
                  checked={paymentMethod === "paypal"}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                />
                PayPal
              </label>
            </div>

            <button type="submit" className="confirm-btn">
              Confirm Booking
            </button>
          </form>
        </div>

        {/* RIGHT SUMMARY */}
        <div className="checkout-right">
          <h2>Booking Summary</h2>
          <div className="booking-card">
            <img src={booking.image} alt={booking.title} />
            <h3>{booking.title}</h3>
            <p>{booking.nights} nights for {booking.guests} guest(s)</p>
            <p>
              <strong>Check-in:</strong> {booking.startDate.toDateString()} <br />
              <strong>Check-out:</strong> {booking.endDate.toDateString()}
            </p>

            <div className="price-breakdown">
              <div className="row">
                <span>{`AED ${booking.pricePerNight.toLocaleString()} X ${booking.nights} nights`}</span>
                <span>AED {(booking.pricePerNight * booking.nights).toLocaleString()}</span>
              </div>
              <div className="row">
                <span>Monthly discount</span>
                <span>-AED 3,226</span>
              </div>
              <div className="row">
                <span>Cleaning fee</span>
                <span>AED 300</span>
              </div>
              <div className="row">
                <span>City / Tourism tax</span>
                <span>AED 106</span>
              </div>
              <hr />
              <div className="row total">
                <span>Total</span>
                <span>
                  AED {booking.totalPrice.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;
